import React, { useEffect } from 'react'

type EmbedTweetProps = {
  tweetId: string;
}

const EmbedTweet = ({ tweetId }: EmbedTweetProps) => {
  useEffect(() => {
    // Load the Twitter script to render the embedded tweet
    const script = document.createElement('script')
    script.src = 'https://platform.twitter.com/widgets.js'
    script.async = true

    document.body.appendChild(script)

    // Clean up the script when the component unmounts
    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <blockquote className='twitter-tweet'>
      <a href={`https://twitter.com/user/status/${tweetId}`}>{`https://twitter.com/user/status/${tweetId}`}</a>
    </blockquote>
  )
}

export default EmbedTweet
